import { render, staticRenderFns } from "./zip-code-field.vue?vue&type=template&id=3f74e528&"
import script from "./zip-code-field.vue?vue&type=script&lang=js&"
export * from "./zip-code-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports